import { showNotification } from "@mantine/notifications";
import React, { useEffect } from "react";
import { Details, ExclamationMark, History, Message } from "tabler-icons-react";

import { useGetIssue } from "api/issues/getIssue";
import { IssueComment, User } from "types";

import IssueForm from "./IssueForm";
import IssueModalSkeleton from "./IssueModalSkeleton";
import ModalTitle from "./ModalTitle";
import { Tabs } from "@mantine/core";
import IssueHistory from "./IssueHistory";
import CommentsTab from "../../Comments";
import { useCommentsByIssue } from "api/comments/useCommentsByIssue";

type IssueModalContentProps = {
  selectedIssue: string;
  onCloseIssueModal: () => void;
  openDeleteModal: boolean;
  onOpenDeleteModal: () => void;
  onCloseDeleteModal: () => void;
  members: User<string>[];
  orgId: string | undefined;
  projectId: string;
};

function IssueModalContent({
  selectedIssue,
  onCloseIssueModal,
  openDeleteModal,
  onOpenDeleteModal,
  onCloseDeleteModal,
  members,
  orgId,
  projectId,
}: IssueModalContentProps) {
  const {
    data: issue,
    isLoading,
    isError,
  } = useGetIssue(selectedIssue, projectId);
  const { data } = useCommentsByIssue(selectedIssue);
  console.log("IssueModalContent", { members });
  const comments: IssueComment[] = data ?? [];
  useEffect(() => {
    if (isError) {
      showNotification({
        title: "Unable to load issue",
        message: "",
        color: "red",
        icon: <ExclamationMark />,
      });
      onCloseIssueModal();
    }
  }, [isError, onCloseIssueModal]);

  if (isLoading || isError) {
    return <IssueModalSkeleton />;
  }

  return (
    <>
      <ModalTitle
        onCloseIssueModal={onCloseIssueModal}
        openDeleteModal={openDeleteModal}
        members={members}
        onOpenDeleteModal={onOpenDeleteModal}
        onCloseDeleteModal={onCloseDeleteModal}
        issue={issue}
        orgId={orgId}
      />

      <Tabs defaultValue="details">
        <Tabs.List>
          <Tabs.Tab value="details" icon={<Details size={14} />}>
            Issue Details
          </Tabs.Tab>
          <Tabs.Tab value="comments" icon={<Message size={14} />}>
            {`Comments (${comments.length})`}
          </Tabs.Tab>
          <Tabs.Tab value="history" icon={<History size={14} />}>
            History
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="details" pt="xs">
          <IssueForm
            issue={issue}
            onCloseIssueModal={onCloseIssueModal}
            members={members}
            orgId={orgId}
          />
        </Tabs.Panel>
        <Tabs.Panel value="comments" pt="xs">
          <CommentsTab
            // userIds={userIds}
            members={members}
            projectId={projectId}
            selectedIssue={selectedIssue}
          />
        </Tabs.Panel>
        <Tabs.Panel value="history" pt="xs">
          <IssueHistory projectId={projectId} issueId={selectedIssue} />
        </Tabs.Panel>
      </Tabs>
    </>
  );
}

export default IssueModalContent;
